import type { ContextlessPoliciesEnum } from 'generated/resources/graphql'

export const POSTS_POLICIES = {
  postsManage: 'Posts_postsManage',
  groupCanPostSomewhere: 'Posts_groupCanPostSomewhere',
  groupCreate: 'Posts_groupCreate',
} as const satisfies Record<string, ContextlessPoliciesEnum>
